import { Typography } from "@mui/material"
import { Box } from "@mui/system"
import RoundEndingViewLinkButton from "components/RoundEndingViewLinkButton"
import { userContext } from "contexts/userContext"
import i18n from "i18n"
import { useContext } from "react"
import { useTranslation } from "react-i18next"
import ClientGroupId from "utils/clientGroupId"

type LinkHolder = {
  url: string
  name: string
}

type ClientGroupHolder = {
  youth: LinkHolder[]
  adults: LinkHolder[]
  elders: LinkHolder[]
}

const LinkSection = () => {
  const { t } = useTranslation()
  const { user } = useContext(userContext)

  const helpLinks: { [name: string]: ClientGroupHolder } = {
    fi: {
      youth: [
        { url: "https://harrastukset.tampere.fi/fi-FI?sort=startDate&contentTab=time-sensetive", name: "Tampereen harrastuskalenteri" },
        { url: "https://mieli.fi/tukea-ja-apua/kriisipuhelin", name: "Ahdistaa ja paha olla" }
      ],
      adults: [
        { url: "https://harrastukset.tampere.fi/fi-FI?sort=startDate&contentTab=time-sensetive", name: "Tampereen harrastuskalenteri" }
      ],
      elders: [
        { url: "https://harrastukset.tampere.fi/fi-FI?sort=startDate&contentTab=time-sensetive", name: "Tampereen harrastuskalenteri" }
      ],
    },
    en: {
      youth: [
        { url: "https://harrastukset.tampere.fi/en-FI?sort=startDate&contentTab=time-sensetive", name: "Tampere hobby calendar" },
        { url: "https://mieli.fi/en/support-and-help/crisis-helpline/", name: "Anxious and the mind is down" }
      ],
      adults: [
        { url: "https://harrastukset.tampere.fi/en-FI?sort=startDate&contentTab=time-sensetive", name: "Tampere hobby calendar" }
      ],
      elders: [
        { url: "https://harrastukset.tampere.fi/en-FI?sort=startDate&contentTab=time-sensetive", name: "Tampere hobby calendar" }
      ]
    },
    se: {
      youth: [
        { url: "https://mieli.fi/sv/stod-och-hjalp/kristelefon/", name: "Psykisk Hälsa Finland" }
      ],
      adults: [],
      elders: [],
    },
    de: {
      youth: [],
      adults: [],
      elders: [],
    }
  }

  const languageVersion: ClientGroupHolder = helpLinks[i18n.language]

  let links =
    user?.clientGroupId === ClientGroupId.ADULTS
      ? languageVersion.adults
      : user?.clientGroupId === 2
        ? languageVersion.elders
        : languageVersion.youth

  const urlButtons = links.map((service, i) => {
    return <RoundEndingViewLinkButton key={i} url={service.url} text={service.name} icon={<></>} />
  })

  return (
    <>
      {links.length > 0 && (
        <Box sx={{ display: "flex", alignItems: "center", flexDirection: "column", mt: 2 }}>
          <Typography
            sx={{ fontFamily: "SofiaProBold", margin: 1 }}
            aria-describedby={t("aria-labels.open-in-new-window")}
          >
            {t("ending-view.links-title")}
          </Typography>
          {urlButtons}
        </Box>
      )}
    </>
  )
}

export default LinkSection
